import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import { Text, TEXT_VARIANT_LIGHT, Icon, Flex } from 'mailup-web-components'
import styled from '@emotion/styled'

import {
  SENDING_SOURCE_IMMEDIATE,
  SENDING_STATUS_FAILED
} from 'Constants/index'

const DateCell = ({
  dateFormatted,
  status,
  retryCounter,
  scheduled,
  source
}) => {
  const intl = useIntl()
  let stringIdTootlip = ''

  if (retryCounter && status !== SENDING_STATUS_FAILED) {
    stringIdTootlip = 'Load.Schedulation.RetrySending'
  }

  const immediateQueued = scheduled && source === SENDING_SOURCE_IMMEDIATE

  return (
    <Flex padding='24px 16px'>
      {immediateQueued ? (
        <Text variant={TEXT_VARIANT_LIGHT}>
          {intl.formatMessage({ id: 'Load.Schedulation.StatusQueued' })}
        </Text>
      ) : (
        <Text variant={TEXT_VARIANT_LIGHT}>
          {dateFormatted}{' '}
          {!!stringIdTootlip && (
            <>
              <StyledWarningIcon
                family='fa'
                icon='exclamation-triangle'
                tooltipText={intl.formatMessage({ id: stringIdTootlip })}
              />
            </>
          )}
        </Text>
      )}
    </Flex>
  )
}

export default DateCell

DateCell.propTypes = {
  dateFormatted: PropTypes.any,
  status: PropTypes.any,
  retryCounter: PropTypes.any,
  scheduled: PropTypes.any,
  source: PropTypes.any
}

const StyledWarningIcon = styled(Icon)`
  color: var(--sun);

  :hover {
    cursor: pointer;
  }
`
